import './styles.scss'
import React from 'react'

const Nixi1Spinner = ({ width = '65px', height = '65px' }) => (
  <svg
    className='nixi1-spinner'
    width={width}
    height={height}
    viewBox='0 0 66 66'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      className='path'
      fill='none'
      strokeWidth='6'
      strokeLinecap='round'
      cx='33'
      cy='33'
      r='30'
    ></circle>
  </svg>
)

export default Nixi1Spinner
